<script setup lang="ts">
import { ToastProvider, ToastViewport } from "reka-ui"
import Toast from "./Toast.vue"
import { useToast } from "./useToast"

const { toasts, removeToast } = useToast()
</script>

<template>
  <ToastProvider>
    <Toast
      v-for="toast in toasts"
      :key="toast.id"
      :toast="toast"
      @close="removeToast(toast.id)"
    />
    <ToastViewport
      class="fixed flex flex-col p-6 gap-2.5 m-0 list-none z-60 outline-hidden w-full bottom-0 left-0 right-0 md:w-97.5 md:top-0 md:right-0 md:bottom-auto md:left-auto"
    />
  </ToastProvider>
</template>
